/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import * as sharedApiAction from './user-auth-api.actions';
import { UserAuthState } from './';

export function reducer(state: UserAuthState, action: sharedApiAction.All): UserAuthState {
  switch (action.type) {
    case sharedApiAction.USER_LOGIN:
      return {
        ...state,
        userDetails: {
          loading: true,
          error: undefined,
          data: undefined
        }
      };

    case sharedApiAction.USER_LOGIN_SUCCESS:
      return {
        ...state,
        userDetails: {
          loading: false,
          error: undefined,
          data: action.userDetails
        }
      };

    case sharedApiAction.USER_LOGIN_ERROR:
      return {
        ...state,
        userDetails: {
          loading: false,
          error: action.errorMessage,
          data: undefined
        }
      };
  }

  return state;
}
